var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTikChannel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7C29480B-5D7B-4FA5-B6FB-9F2261173229@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kitly-App_1",
    transform: "translate(-982.000000, -872.000000)",
    fill: "#111111",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/insta-Copy-6",
    transform: "translate(982.000000, 872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tiktok",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09107887,8.93775 L9.09107887,13.06275 C7.98345236,12.7854675 6.80311278,12.9999237 5.88165255,13.6458713 C4.96019232,14.2918189 4.39703224,15.2995636 4.35038069,16.386 C4.28742838,17.3203702 4.65297628,18.2349717 5.35300697,18.8945729 C6.05303766,19.5541742 7.01923194,19.8944015 8.00308864,19.82775 C10.7021261,19.82775 11.6557966,18.02775 11.6557966,16.3395 L11.6557966,0 L15.9524494,0 C16.683307,4.31475 18.9548915,5.316 22,5.77875 L22,9.91275 C22,9.91275 18.387588,9.669 16.0741273,8.013 L16.0741273,16.17975 C16.0717569,19.875 13.763827,24 8.03548341,24 C2.71958052,24 0,19.725 0,16.1415 C0.0685608286,13.9939395 1.10221497,11.9769349 2.83982143,10.6000595 C4.57742788,9.22318417 6.85279565,8.61812742 9.09107887,8.93775 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikChannel);
export default __webpack_public_path__ + "static/media/tikChannel.307a61b36f6747727728b5ae1b64f7b8.svg";
export { ForwardRef as ReactComponent };